import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckIsAdmin, ApiDeleteUser, ApiGetUser, ApiRegister, ApiUpdateUser } from "utils/constants/api";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import { useModal } from "utils/context/ModalContext";
import { UserService } from "services/UserService";
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { AuthService } from "services/AuthService";
import { PagesFormTitle } from "components/Cards/PagesFormTitle";
import { FormCard } from "components/Cards/FormCard";


export default function UserForm(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchCheckIsAdmin } = AuthService()
    const { fetchCreateUser, fetchUpdateUser, fetchUserById, fetchDeleteUser } = UserService()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramUserId = queryString.get("userId")
    
    const [userId, setUserId] = useState(EmptyString)
    const [username, setUsername] = useState(EmptyString)
    const [firstName, setFirstName] = useState(EmptyString)
    const [lastName, setLastName] = useState(EmptyString)
    const [email, setEmail] = useState(EmptyString)    
    const [password, setPassword] = useState(EmptyString)    
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [isAdmin, setIsAdmin] = useState(false)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)


    // Function Button
    const saveBtnClick = async () => {
        if (!validateForm()) return

        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            if(formType === FormTypeAdd){
                await fetchCreateUser(
                    username,
                    firstName,
                    lastName,
                    email,
                    password,
                    isAdmin
                )
            }else{
                await fetchUpdateUser(
                    paramUserId,
                    username,
                    firstName,
                    lastName,
                    email,
                    password,
                    isAdmin
                )
            }
        } finally {
            hideLoading()

            showSuccess({
                onSuccess: () => {
                    navigate('/setting/user')
                }
            })
        }
    }
    const deleteBtnClick = async () => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchDeleteUser(userId, status)
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/setting/user')
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate("/setting/user")
    }

    // Function
    function validateForm(){
        let errorCount = 0
        let error = false

        if (password !== confirmPassword) {
            showFail("Password did not match!")
            return false
        }

        // if (formType === FormTypeEdit){
        //     if (userId === EmptyString || userId === null){
        //         setErrorUserId(true)
        //         errorCount++
        //     }else{
        //         setErrorUserId(false)
        //     }
        // }

        // if (username === EmptyString || username === null){
        //     setErrorUsername(true)
        //     errorCount++
        // }else{
        //     setErrorUsername(false)
        // }

        // if (firstName === EmptyString || firstName === null){
        //     setErrorFirstName(true)
        //     errorCount++
        // }else{
        //     setErrorFirstName(false)
        // }

        // if (lastName === EmptyString || lastName === null){
        //     setErrorLastName(true)
        //     errorCount++
        // }else{
        //     setErrorLastName(false)
        // }

        // if (password === EmptyString || password === null){
        //     setErrorPassword(true)
        //     errorCount++
        // }else{
        //     setErrorPassword(false)
        // }

        // if (confirmPassword === EmptyString || confirmPassword === null){
        //     setErrorConfirmPasswordMessage("Confirm Password is required")
        //     setErrorConfirmPassword(true)
        //     errorCount++
        // }else{
        //     setErrorConfirmPassword(false)
        // }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            // setErrorConfirmPasswordMessage("Password did not match!")
            // setErrorConfirmPassword(true)
        }else{
            // setErrorConfirmPassword(false)
        }
    }

    const getUserById = async () => {
        const res = await fetchUserById(paramUserId)
        if (!res) return

        const data = res.data
        setUserId(data.id)
        setUsername(data.username)
        setFirstName(data.firstName)
        setLastName(data.lastName)
        setEmail(data.email)
        setIsAdmin(data.isAdmin)

        setStatus(data.status)
        setCreateDate(data.createDate)
        setUpdateDate(data.updateDate)
        setUpdateBy(data.updateBy)
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                const res = await fetchCheckIsAdmin(localStorage.getItem("UserId"))
                if (!res) return

                if (res.data.isAdmin === false){
                    showFail("User don't have admin access right!")
                }

                if (formType === FormTypeEdit || formType === FormTypeView){
                    await getUserById()
                }
            } finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return(
        <MainBodyCard>
            <PagesFormTitle
                title='Tenant Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateBy={updateBy}
                updateDate={updateDate}
            />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Username'>
                    <input className="input" value={ username } onChange={(e) => { setUsername(e.target.value) }} maxLength={20} />
                </FormCard>

                <FormCard title='First Name'>
                    <input className="input" value={ firstName } onChange={(e) => { setFirstName(e.target.value) }} maxLength={30} />
                </FormCard>

                <FormCard title='Last Name'>
                    <input className="input" value={ lastName } onChange={(e) => { setLastName(e.target.value) }} maxLength={30} />
                </FormCard>

                <FormCard title='Password'>
                    <input type="password" className="input" value={ password } onChange={(e) => { setPassword(e.target.value) }} />
                </FormCard>

                <FormCard title='Confirm Password'>
                    <input type="password" className="input" value={ confirmPassword } onChange={(e) => { setConfirmPassword(e.target.value) }} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} />
                </FormCard>

                <FormCard title='Admin'>
                    <input type="checkbox" className="" value={isAdmin} onChange={(e) => { setIsAdmin(!isAdmin) }} checked={isAdmin} />
                </FormCard>
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? true : false} />
                <BackButton onClick={backBtnClick} />
            </div>
        </MainBodyCard>
    )
}